(() => {
  if (customElements.get("ff-coupons")) {
    return;
  }

  class FiftyFlowersCoupons extends HTMLElement {
    constructor() {
      super();
      this.copying = false;
    }

    connectedCallback() {
      this.addEventListener("click", this.handleClick);
    }

    handleClick = (event) => {
      const couponCode = event.target.closest(".ff-coupon__code");
      if (couponCode) {
        this.copyCouponCode(couponCode);
      }
    };

    copyCouponCode(element) {
      const couponCode = element.getAttribute("data-coupon-code");

      if (!navigator.clipboard) {
        console.error("Clipboard API is not supported");
        return;
      }

      if (this.copying) {
        return;
      }

      if (!couponCode) {
        console.error("No coupon code found");
        return;
      }

      navigator.clipboard
        .writeText(couponCode)
        .then(() => {
          const originalText = element.textContent;
          element.textContent = "COPIED";
          this.copying = true;
          setTimeout(() => {
            element.textContent = originalText;
            this.copying = false;
          }, 2000);
        })
        .catch((err) => {
          console.error("Failed to copy: ", err);
        });
    }
  }

  customElements.define("ff-coupons", FiftyFlowersCoupons);
})();
